import React from 'react'
import './ui.css'

/**
 * Табы с подчёркиванием активного (контент панелей — снаружи).
 * tabs: { id, label, summary? }[]
 */
function UnderlineTabs ({
  tabs,
  activeId,
  onChange,
  className = '',
  ariaLabel = 'Вкладки'
}) {
  if (!tabs?.length) return null
  return (
    <div className={`ds-tabs ${className}`.trim()} role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => {
        const active = tab.id === activeId
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            id={`tab-${tab.id}`}
            aria-selected={active}
            aria-controls={`panel-${tab.id}`}
            className={`ds-tab${active ? ' ds-tab-active' : ''}`}
            onClick={() => onChange?.(tab.id)}
          >
            {tab.label}
            {tab.summary != null && tab.summary !== '' && (
              <span className="ds-tab-summary">{tab.summary}</span>
            )}
          </button>
        )
      })}
    </div>
  )
}

export default UnderlineTabs
